import { render, staticRenderFns } from "./Stimmet.vue?vue&type=template&id=93b00854&scoped=true&"
import script from "./Stimmet.vue?vue&type=script&lang=js&"
export * from "./Stimmet.vue?vue&type=script&lang=js&"
import style0 from "./Stimmet.vue?vue&type=style&index=0&id=93b00854&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b00854",
  null
  
)

export default component.exports